import "./new-user-controller"
import "./new-user-confirmation-fail-controller"
import "./new-user-confirmation-success-controller"
import "./new-user-confirmation-controller";
import "./termos-servico-controller";